export default __webpack_public_path__ + "static/media/coco-header-logo.f2c1b9d3.svg";